import { c as _c } from "react/compiler-runtime";
import { useContext, useMemo } from "react";
import { thousandize } from "../../../../util/formatting";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import { InterventionWidgetOutput, InterventionWidgetOutputConfiguration } from "../InterventionWidget/InterventionWidgetOutput";
import { WidgetContext } from "../../layout/layout";
import { RecurringDonation } from "../../../shared/components/Widget/types/Enums";
import styles from "./WealthCalculator.module.scss";
import { usePlausible } from "next-plausible";
import { Wealthcalculatorimpact } from "../../../../studio/sanity.types";
export type WealthCalculatorImpactConfig = Wealthcalculatorimpact & {
  intervention_configuration: {
    output_configuration: InterventionWidgetOutputConfiguration;
    currency: string;
    locale: string;
  };
};
export const WealthCalculatorImpact: React.FC<{
  donationPercentage: number;
  setDonationPercentage: (value: number) => void;
  postTaxIncome: number;
  config: WealthCalculatorImpactConfig;
}> = t0 => {
  const $ = _c(33);
  const {
    donationPercentage,
    postTaxIncome,
    config
  } = t0;
  const [, setWidgetContext] = useContext(WidgetContext);
  const plausible = usePlausible();
  const donationAmount = Math.round(postTaxIncome * (donationPercentage / 100));
  const t1 = config.header || "Din impact.";
  let t2;
  if ($[0] !== t1) {
    t2 = <h3>{t1}</h3>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== config.description_template_string || $[3] !== donationAmount) {
    t3 = config.description_template_string?.replace("{donation}", thousandize(donationAmount)) || "Missing description template.";
    $[2] = config.description_template_string;
    $[3] = donationAmount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p>{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== donationAmount || $[8] !== plausible || $[9] !== setWidgetContext) {
    t5 = () => {
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      plausible("OpenDonationWidgetWealthCalculatorImpactCTA", {
        props: {
          page: window.location.pathname
        }
      });
      setWidgetContext({
        open: true,
        prefilled: null,
        prefilledSum: Math.round(donationAmount / 12 / 100) * 100,
        prefilledRecurring: RecurringDonation.RECURRING
      });
    };
    $[7] = donationAmount;
    $[8] = plausible;
    $[9] = setWidgetContext;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = config.button_text || "Sett opp fast donasjon";
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className={styles.calculator__impact__description__button_desktop} data-cy="wealthcalculator-impact-create-agreement-button"><EffektButton onClick={t5}>{t6}</EffektButton></div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t4 || $[16] !== t7) {
    t8 = <div className={styles.calculator__impact__description}>{t2}{t4}{t7}</div>;
    $[14] = t2;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== config.intervention_configuration.currency || $[19] !== config.intervention_configuration.locale || $[20] !== config.intervention_configuration.output_configuration || $[21] !== donationAmount) {
    t9 = <div className={styles.calculator__impact__output}><InterventionWidgetOutput sum={donationAmount} configuration={config.intervention_configuration.output_configuration} currency={config.intervention_configuration.currency} locale={config.intervention_configuration.locale} /></div>;
    $[18] = config.intervention_configuration.currency;
    $[19] = config.intervention_configuration.locale;
    $[20] = config.intervention_configuration.output_configuration;
    $[21] = donationAmount;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== donationAmount || $[24] !== setWidgetContext) {
    t10 = () => setWidgetContext({
      open: true,
      prefilled: null,
      prefilledSum: Math.round(donationAmount / 12 / 100) * 100,
      prefilledRecurring: RecurringDonation.RECURRING
    });
    $[23] = donationAmount;
    $[24] = setWidgetContext;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const t11 = config.button_text || "Sett opp fast donasjon";
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <div className={styles.calculator__impact__description__button_mobile}><EffektButton onClick={t10}>{t11}</EffektButton></div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t8 || $[31] !== t9) {
    t13 = <div className={styles.calculator__impact}>{t8}{t9}{t12}</div>;
    $[29] = t12;
    $[30] = t8;
    $[31] = t9;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  return t13;
};